import React from "react";

import AttributeCarousel, {
  ArrowSize,
} from "@is/components/AttributeCarousel/AttributeCarousel";
import LanguageAndCountryButton from "@is/components/LanguageAndCountryButton";
import SignUpButton from "@is/components/SignUpButton";
import { AttributeSetting } from "@is/types";

import css from "./PrimaryAttributeHeader.module.css";
import useManagePrimaryAttributeHeader from "./hooks/useManagePrimaryAttributeHeader";

type Props = {
  attributes: AttributeSetting[];
  onAttributeClick: (event: React.SyntheticEvent<HTMLButtonElement>) => void;
  onLanguageAndCurrencyClick: () => void;
  onSignUpClick: () => void;
  showSignUpButton: boolean;
  signUpButtonTitle: string;
};

const PrimaryAttributeHeader = ({
  attributes,
  onAttributeClick,
  onLanguageAndCurrencyClick,
  onSignUpClick,
  signUpButtonTitle,
  showSignUpButton,
}: Props) => {
  const { sliderAdditionalOptions, AttributeCarouselContent } =
    useManagePrimaryAttributeHeader({
      attributes,
      onAttributeClick,
      showSignUpButton,
    });

  return (
    <div className={css.header}>
      <AttributeCarousel
        additionalOptions={sliderAdditionalOptions}
        arrowsSize={ArrowSize.XS}
        content={AttributeCarouselContent}
      />
      <div className={css.buttonsContainer}>
        {showSignUpButton && (
          <SignUpButton title={signUpButtonTitle} onClick={onSignUpClick} />
        )}
        <div className={css.languageButton}>
          <LanguageAndCountryButton onClick={onLanguageAndCurrencyClick} />
        </div>
      </div>
    </div>
  );
};

export default PrimaryAttributeHeader;
